import Header from "@/components/Header";
import SchoolHub from "@/components/school/SchoolHub";
import { schoolApi } from "@/lib/school";

export default function School() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FDFBF7]" data-testid="school-page">
      <Header />
      <main className="flex-1"><SchoolHub api={schoolApi} theme="qfc" onlyApp="qfc" /></main>
    </div>
  );
}
